import { incomeFormToQuery as formToQuery } from './incomeFormToQuery';
import { incomeQueryToForm as queryToForm } from './incomeQueryToForm';

export default { formToQuery, queryToForm };
